// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/scrollbars.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dataset detail inspector — layout aligned with 02_dataset_detail.svg */

.xPGB8CoeNCacgtsb24pu {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  background: #f0f0f0;
}

.UyAPUAAxxSpIgmHIXrFv {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  font-family: var(--curio-font-family, Rubik, Inter, system-ui, sans-serif);
  color: #1e1f23;
}

/* No padding and no border of its own. \`CatalogDetailHeader\` - the shared
 * header all three details views render - owns both, and it is the whole of
 * this element's content. Padding here inset the shared header inside a second
 * padded box, so the Data one alone sat narrower than its peers and started
 * lower; the border drew a second rule under the header's own.
 *
 * Kept as an element because the tab strip below it belongs to the same
 * flex-shrink:0 band. */
.govLgMqvf19UZSjaqi_z {
  flex-shrink: 0;
  background: #fafafa;
  padding: 0;
}

.hGHvAM_1oGc1rjkvabD5 {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  color: #888;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.hGHvAM_1oGc1rjkvabD5 strong {
  color: #1e1f23;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
}

.nPGvhyMsWjSpJdpFkqeM {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 12px 0 8px;
}

.Ig1xFQojYOAaLK9Y133S {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.M8dBsLmmV9mPsnfqInxt {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
}

.bpoWsK2lLsYzy916CoEw {
  background: #dff2e1;
  color: #2f8f4a;
}

.hUEo5yq6QZZT81UVs7pw {
  background: #dce8ff;
  color: #3b6fd4;
}

.uYl2lPJkd94ExEXE5X8m {
  background: #eadcfb;
  color: #7a4bd1;
}

.Xz4ysZlQywAu9Lorz056 h1,
.Ig1xFQojYOAaLK9Y133S h1 {
  margin: 0 0 6px;
  color: #1e1f23;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.2;
}

.PMjHgaIE4xFiCKQhoxsu {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  color: #555;
  font-size: 11px;
  font-weight: 600;
}

.wW91JI1D3HYNYhdU1LkA {
  color: #d0d0d0;
  font-weight: 400;
}

.TiQ66T8yoO86yTDbKRBZ,
.Tcjb3lA6WKjfF_Tc31VU {
  display: inline-flex;
  align-items: center;
  min-height: 20px;
  border-radius: 10px;
  padding: 2px 10px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.TiQ66T8yoO86yTDbKRBZ {
  background: #e9eef3;
  color: #415363;
}

/* Format identity, shared with every other surface that shows one. */
.D1JS5NOycDERk4YMB8yl { background: var(--curio-format-geojson-bg); color: var(--curio-format-geojson-on-tint); }
.m1yOVubNLVVDRIaufqr2 { background: var(--curio-format-csv-bg); color: var(--curio-format-csv-on-tint); }
.nWRlY5VsCV9Ps2y9W7Nw { background: var(--curio-format-json-bg); color: var(--curio-format-json-on-tint); }
.hOWv813TkvxaZ8wWhyQY { background: var(--curio-format-parquet-bg); color: var(--curio-format-parquet-on-tint); }
.FX1q6M3b1AfXxWTyylVj { background: var(--curio-format-geotiff-bg); color: var(--curio-format-geotiff-on-tint); }
.t4S8EJheoafyuKSmphDv { background: var(--curio-format-shp-bg); color: var(--curio-format-shp-on-tint); }
.wlAtUFEkrBIvb6q5JbB5 { background: var(--curio-format-bundle-bg); color: var(--curio-format-bundle-on-tint); }
.FZRY1n9F_WKS4uwdhoz0 { background: var(--curio-format-osm-bg); color: var(--curio-format-osm-on-tint); }
.kpbHYM3hFzeczrqpPdBz { background: var(--curio-format-gpkg-bg); color: var(--curio-format-gpkg-on-tint); }
.TXtTK3w_kB8PZZyA8PS0 { background: var(--curio-format-gtfs-bg); color: var(--curio-format-gtfs-on-tint); }
.YQNkHREMUa49fE_wZpGE { background: var(--curio-format-collection-bg); color: var(--curio-format-collection-on-tint); }
.KBZuxgr_PUob_qA9sjlN { background: var(--curio-format-onnx-bg); color: var(--curio-format-onnx-on-tint); }
.Jo_REQxlOIL9OyrxIjRh { background: var(--curio-format-netcdf-bg); color: var(--curio-format-netcdf-on-tint); }

.Tcjb3lA6WKjfF_Tc31VU {
  background: #1e1f23;
  color: #fff;
}

.XJTNgdhK7KUkyNStkaA_ {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  padding-top: 4px;
}

/* \`.publishButton\` and \`.unpublishButton\` are gone with the controls they
 * styled: this panel is the details view and no longer decides publishing.
 * The red \`.unpublishButton\` was also the one place in the catalogs that used a
 * third colour - the vocabulary is dark for an action, light for a destructive
 * one, and nothing else. */
.o9_z8rXBLUJ9oZfzJ7xw {
  min-height: 34px;
  border-radius: 7px;
  padding: 0 14px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  /* Export is an action, so it takes the action fill like every other action
     in the catalogs. It was the odd one out: a grey outline on a panel whose
     other buttons were solid dark. */
  border: 0;
  background: var(--curio-top-bar-bg);
  color: var(--curio-text-on-dark);
}

.o9_z8rXBLUJ9oZfzJ7xw:hover:not(:disabled) {
  background: var(--curio-top-bar-bg-hover);
}

.o9_z8rXBLUJ9oZfzJ7xw:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* Its own inset now that \`.pageHeader\` does not pad: the tabs used to inherit
 * the header band's 24px and would otherwise sit flush against the edge. */
.UnOH6pP3wTz7ebnslHLK {
  display: flex;
  align-items: center;
  gap: 18px;
  min-height: 36px;
  margin-top: 4px;
  padding: 0 24px;
}

.UnOH6pP3wTz7ebnslHLK button {
  align-self: stretch;
  border: 0;
  border-bottom: 3px solid transparent;
  background: transparent;
  color: #777;
  padding: 0 2px 8px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.P367ON01mFW3diV7Jjle {
  color: #1e1f23 !important;
  font-weight: 700 !important;
  border-bottom-color: #1e1f23 !important;
}

/* Three-column split body (schema | main content | info+lineage) */
.UtphHzorqJ5l1pMW0Rct {
  flex: 1;
  display: grid;
  grid-template-columns: minmax(240px, 20.6%) minmax(0, 1fr) minmax(280px, 27.8%);
  min-height: 0;
  overflow: hidden;
}

/* Focused tabs (Schema / Table Preview / Lineage) hide the schema column. */
.iAPP2zfyahJJtiIJPpfH {
  grid-template-columns: minmax(0, 1fr) minmax(280px, 27.8%);
}

.Y2A2sLIsg1FJyNHOmIwK,
.oTZoOKQv5T8Fe_z6djyg,
.a_3E3fas3zeTaWdwTR5c {
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.Y2A2sLIsg1FJyNHOmIwK > * {
  flex: 1;
  min-height: 0;
}

/* The scrollable columns (this one and .infoColumn) take the shared thin
   scrollbar. */
.oTZoOKQv5T8Fe_z6djyg {
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
  overflow-y: auto;
}

.iAPP2zfyahJJtiIJPpfH .oTZoOKQv5T8Fe_z6djyg {
  border-left: 0;
}

.FhG0BBPlN6jVARS4FOzY {
  flex-shrink: 0;
}

.ouTpcgrunBKv5XnHT3oB {
  min-height: 38px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  background: #fafafa;
  border-bottom: 1px solid #e5e5e5;
}

.RJgusxnq_SyOCNgadxN3 {
  font-size: 13px;
  font-weight: 700;
  color: #1e1f23;
  padding-bottom: 8px;
  border-bottom: 3px solid #1e1f23;
}

/* Expanded lineage view (center column, Lineage tab) */
.mManFzCvgziXHPuxgrXo {
  flex: 1;
  min-height: 180px;
  background: #fff;
  padding: 16px 20px 24px;
}

.o7CT9QHrO1WCHrl6QN0g h2 {
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #1e1f23;
}

.GOTQL_1IWr1_YqlkH5_P {
  border-radius: 9px;
  background: #f2f2f4;
  color: #85858f;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.o7CT9QHrO1WCHrl6QN0g p {
  margin: 6px 0 0;
  color: #777;
  font-size: 11px;
}

/* Compact lineage summary + states (right sidebar) */
.p9MpLRAENshkzkiU8mkr {
  margin: 0 0 10px;
  color: #1e1f23;
  font-size: 12px;
  font-weight: 600;
}

.cnxbDwENt4Ov0WiuD2Tf {
  margin: 0 0 10px;
  border-left: 2px solid #e3bf85;
  color: #6b6b76;
  padding: 2px 0 2px 8px;
  font-size: 11px;
}

.fS7VMFnAaaCXHDSgJx6C {
  margin: 4px 0 8px;
  color: #777;
  font-size: 11px;
}

.ddmPjoZPGLBErUHVicJg {
  margin: 0 0 10px;
}

.zjq3mseBkati74mtWdFj {
  cursor: pointer;
  list-style-position: outside;
  margin: 0 0 8px;
  color: #999;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  user-select: none;
}

.PvfYIx0Abj6hL_sGTHuy {
  align-self: center;
  border-radius: 9px;
  padding: 1px 8px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}

.mSOWEPZeZ7LXrdGQvIQd {
  border: 1px solid #e8d7ba;
  color: #8a6a30;
}

.qPY84pBx7CDdWJYtjoHN {
  border: 1px solid #e8cfcf;
  color: #97595a;
}

.aet0QYgpHFDEyADTtwCK {
  margin: 22px 0 6px;
  color: #1e1f23;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.BMSFMyf0yZ08K7j7cWei,
.ju4kk9e5xM4cHetTsqjy,
.AratndiDzIWsgelNTVCd,
.mMlKVhOUdVfI9CLplSp8 {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  min-height: 40px;
  margin: 0;
  border: 0;
  border-bottom: 1px solid #f0f0f0;
  border-radius: 0;
  background: transparent;
  padding: 8px 0;
  overflow: hidden;
}

.SYg1oI1uIrBSNFflG2wr {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.SYg1oI1uIrBSNFflG2wr strong,
.ju4kk9e5xM4cHetTsqjy strong,
.AratndiDzIWsgelNTVCd strong,
.mMlKVhOUdVfI9CLplSp8 strong {
  color: #1e1f23;
  font-size: 11px;
  font-weight: 600;
}

.KTm4b9WdsEcHEMQ4fDHv {
  align-self: flex-start;
  border-radius: 7px;
  background: #f2f2f4;
  color: #85858f;
  padding: 1px 7px;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.blbJeD8z6xaKYVLR50mE,
.ju4kk9e5xM4cHetTsqjy span,
.AratndiDzIWsgelNTVCd span,
.mMlKVhOUdVfI9CLplSp8 span {
  color: #777;
  font-size: 11px;
}


/* Right info column */
.a_3E3fas3zeTaWdwTR5c {
  overflow-y: auto;
}

._Z7q8oEeHd1pmID1IU2r {
  min-height: 44px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  background: #fafafa;
  border-bottom: 1px solid #ebebeb;
  flex-shrink: 0;
}

._Z7q8oEeHd1pmID1IU2r h2 {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  color: #1e1f23;
}

.Mufrd3mp5sZkEvfoGj_A {
  padding: 16px 20px;
  border-bottom: 1px solid #ebebeb;
}

.FhKnCqCpscte4rsvm4b7 {
  margin: 0 0 12px;
  color: #999;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.MP5XbGftZSDbrdtrncDb {
  margin: 0;
}

.MP5XbGftZSDbrdtrncDb > div {
  display: grid;
  grid-template-columns: minmax(100px, 1fr) minmax(0, 1.2fr);
  gap: 12px;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f5f5f5;
  font-size: 13px;
}

.MP5XbGftZSDbrdtrncDb > div:last-child {
  border-bottom: 0;
}

.MP5XbGftZSDbrdtrncDb dt {
  margin: 0;
  color: #555;
  font-size: 11px;
  font-weight: 600;
}

.MP5XbGftZSDbrdtrncDb dd {
  margin: 0;
  color: #1e1f23;
  font-weight: 400;
  text-align: right;
}

.ju4kk9e5xM4cHetTsqjy > div:first-child,
.AratndiDzIWsgelNTVCd > div:first-child {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

/* hubSourceCard puts its name and caption straight in the row. */
.mMlKVhOUdVfI9CLplSp8 {
  grid-template-columns: minmax(0, 1fr);
  align-content: center;
  row-gap: 2px;
}

.mMlKVhOUdVfI9CLplSp8 strong {
  color: #1e1f23;
  font-size: 11px;
  font-weight: 600;
}

.mMlKVhOUdVfI9CLplSp8 span {
  color: #777;
  font-size: 11px;
}

.cKqIgsAsdMxSHG5_ShAw {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.iHrG3aGcbXeDyxVt417d {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  border-radius: 11px;
  background: #f0f0f0;
  color: #555;
  padding: 0 12px;
  font-size: 11px;
}

.gre3QeJFACrByDo3wahG,
.oBCq8S0DX8JbqOoaYaGE {
  margin: 0;
  padding: 24px;
  text-align: center;
  color: #777;
  font-size: 13px;
}

.oBCq8S0DX8JbqOoaYaGE {
  color: #9f3f3f;
}

@media (max-width: 1100px) {
  .UtphHzorqJ5l1pMW0Rct {
    grid-template-columns: minmax(200px, 28%) minmax(0, 1fr);
    grid-template-rows: minmax(0, 1fr) auto;
  }

  .iAPP2zfyahJJtiIJPpfH {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: minmax(0, 1fr) auto;
  }

  .Y2A2sLIsg1FJyNHOmIwK {
    grid-row: 1 / span 2;
  }

  .a_3E3fas3zeTaWdwTR5c {
    grid-column: 2;
  }

  .iAPP2zfyahJJtiIJPpfH .a_3E3fas3zeTaWdwTR5c {
    grid-column: 1;
  }

  .oTZoOKQv5T8Fe_z6djyg {
    border-right: 0;
  }
}

@media (max-width: 760px) {
  .nPGvhyMsWjSpJdpFkqeM {
    flex-direction: column;
  }

  .UtphHzorqJ5l1pMW0Rct {
    display: block;
    overflow: auto;
  }

  .Y2A2sLIsg1FJyNHOmIwK,
  .oTZoOKQv5T8Fe_z6djyg,
  .a_3E3fas3zeTaWdwTR5c {
    min-height: 320px;
    border: 0;
    border-bottom: 1px solid #e5e5e5;
  }
}

/* "Use in a node": the reference to paste, and where the bytes live (#206). */
.MUmooIXZI7Z0Iv2neU9o {
    display: flex;
    /* The info column is about 240 px wide and the labelled Copy button takes
       about 174 of them, which left the code a 45 px box (#500). The code gets
       the row to itself and the button goes under it. */
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
}

._0J_BE44qbEYMHa3FPrO5 {
    flex: 1 1 100%;
    /* A reference is one token and can be long, and a layer group's is its
       loader, a line per layer; keep the lines and scroll them rather than wrap
       code the reader is about to copy. */
    min-width: 0;
    overflow-x: auto;
    white-space: pre;
    padding: 6px 8px;
    border-radius: var(--curio-radius-sm);
    background: var(--curio-page-bg);
    font-family: 'Source Code Pro', Consolas, 'Courier New', monospace;
    font-size: var(--curio-font-size-sm);
    color: var(--curio-text-primary);
}

.jcEm8zRG385n1QXUrZe3 {
    margin: 6px 0 0;
    /* Informational: the machine-specific location, which is exactly what
       should NOT be pasted into a node. */
    overflow-wrap: anywhere;
    font-size: var(--curio-font-size-sm);
    color: var(--curio-text-muted);
}
`, "",{"version":3,"sources":["webpack://./src/components/datasets/catalog/DatasetDetailPanel.module.css"],"names":[],"mappings":"AAAA,yEAAyE;;AAEzE;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,0EAA0E;EAC1E,cAAc;AAChB;;AAEA;;;;;;;wBAOwB;AACxB;EACE,cAAc;EACd,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,qEAAqE;AACrE,wBAAkB,0CAA0C,EAAE,0CAA0C,EAAE;AAC1G,wBAAc,sCAAsC,EAAE,sCAAsC,EAAE;AAC9F,wBAAe,uCAAuC,EAAE,uCAAuC,EAAE;AACjG,wBAAkB,0CAA0C,EAAE,0CAA0C,EAAE;AAC1G,wBAAkB,0CAA0C,EAAE,0CAA0C,EAAE;AAC1G,wBAAc,sCAAsC,EAAE,sCAAsC,EAAE;AAC9F,wBAAiB,yCAAyC,EAAE,yCAAyC,EAAE;AACvG,wBAAc,sCAAsC,EAAE,sCAAsC,EAAE;AAC9F,wBAAe,uCAAuC,EAAE,uCAAuC,EAAE;AACjG,wBAAe,uCAAuC,EAAE,uCAAuC,EAAE;AACjG,wBAAqB,6CAA6C,EAAE,6CAA6C,EAAE;AACnH,wBAAe,uCAAuC,EAAE,uCAAuC,EAAE;AACjG,wBAAiB,yCAAyC,EAAE,yCAAyC,EAAE;;AAEvG;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;2BAI2B;AAC3B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;qCAEmC;EACnC,SAAS;EACT,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;2EAC2E;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA,mEAAmE;AACnE;EACE,OAAO;EACP,aAAa;EACb,+EAA+E;EAC/E,aAAa;EACb,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE,0DAA0D;AAC5D;;AAEA;;;EAGE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;AACf;;AAEA;eACe;AACf;EAEE,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,uDAAuD;AACvD;EACE,OAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,qDAAqD;AACrD;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;;;EAIE,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;;;;EAIE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;;;EAIE,WAAW;EACX,eAAe;AACjB;;;AAGA,sBAAsB;AACtB;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA,iEAAiE;AACjE;EACE,qCAAqC;EACrC,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,wDAAwD;IACxD,uCAAuC;EACzC;;EAEA;IACE,qCAAqC;IACrC,uCAAuC;EACzC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;;;IAGE,iBAAiB;IACjB,SAAS;IACT,gCAAgC;EAClC;AACF;;AAEA,8EAA8E;AAC9E;IACI,aAAa;IACb;;wDAEoD;IACpD,eAAe;IACf,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd;;0CAEsC;IACtC,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,qCAAqC;IACrC,gCAAgC;IAChC,kEAAkE;IAClE,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf;0CACsC;IACtC,uBAAuB;IACvB,oCAAoC;IACpC,8BAA8B;AAClC","sourcesContent":["/* Dataset detail inspector — layout aligned with 02_dataset_detail.svg */\n\n.modalRoot {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  height: 100%;\n  background: #f0f0f0;\n}\n\n.inspector {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  font-family: var(--curio-font-family, Rubik, Inter, system-ui, sans-serif);\n  color: #1e1f23;\n}\n\n/* No padding and no border of its own. `CatalogDetailHeader` - the shared\n * header all three details views render - owns both, and it is the whole of\n * this element's content. Padding here inset the shared header inside a second\n * padded box, so the Data one alone sat narrower than its peers and started\n * lower; the border drew a second rule under the header's own.\n *\n * Kept as an element because the tab strip below it belongs to the same\n * flex-shrink:0 band. */\n.pageHeader {\n  flex-shrink: 0;\n  background: #fafafa;\n  padding: 0;\n}\n\n.breadcrumb {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  color: #888;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.breadcrumb strong {\n  color: #1e1f23;\n  font-weight: 600;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.headerMain {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n  padding: 12px 0 8px;\n}\n\n.titleBlock {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  min-width: 0;\n}\n\n.datasetIcon {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.icon_mint {\n  background: #dff2e1;\n  color: #2f8f4a;\n}\n\n.icon_sky {\n  background: #dce8ff;\n  color: #3b6fd4;\n}\n\n.icon_lilac {\n  background: #eadcfb;\n  color: #7a4bd1;\n}\n\n.inspectorHeader h1,\n.titleBlock h1 {\n  margin: 0 0 6px;\n  color: #1e1f23;\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: 0;\n  line-height: 1.2;\n}\n\n.inspectorMeta {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  color: #555;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.metaDot {\n  color: #d0d0d0;\n  font-weight: 400;\n}\n\n.formatChip,\n.installedBadge {\n  display: inline-flex;\n  align-items: center;\n  min-height: 20px;\n  border-radius: 10px;\n  padding: 2px 10px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.formatChip {\n  background: #e9eef3;\n  color: #415363;\n}\n\n/* Format identity, shared with every other surface that shows one. */\n.format_geojson { background: var(--curio-format-geojson-bg); color: var(--curio-format-geojson-on-tint); }\n.format_csv { background: var(--curio-format-csv-bg); color: var(--curio-format-csv-on-tint); }\n.format_json { background: var(--curio-format-json-bg); color: var(--curio-format-json-on-tint); }\n.format_parquet { background: var(--curio-format-parquet-bg); color: var(--curio-format-parquet-on-tint); }\n.format_geotiff { background: var(--curio-format-geotiff-bg); color: var(--curio-format-geotiff-on-tint); }\n.format_shp { background: var(--curio-format-shp-bg); color: var(--curio-format-shp-on-tint); }\n.format_bundle { background: var(--curio-format-bundle-bg); color: var(--curio-format-bundle-on-tint); }\n.format_osm { background: var(--curio-format-osm-bg); color: var(--curio-format-osm-on-tint); }\n.format_gpkg { background: var(--curio-format-gpkg-bg); color: var(--curio-format-gpkg-on-tint); }\n.format_gtfs { background: var(--curio-format-gtfs-bg); color: var(--curio-format-gtfs-on-tint); }\n.format_collection { background: var(--curio-format-collection-bg); color: var(--curio-format-collection-on-tint); }\n.format_onnx { background: var(--curio-format-onnx-bg); color: var(--curio-format-onnx-on-tint); }\n.format_netcdf { background: var(--curio-format-netcdf-bg); color: var(--curio-format-netcdf-on-tint); }\n\n.installedBadge {\n  background: #1e1f23;\n  color: #fff;\n}\n\n.inspectorActions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  padding-top: 4px;\n}\n\n/* `.publishButton` and `.unpublishButton` are gone with the controls they\n * styled: this panel is the details view and no longer decides publishing.\n * The red `.unpublishButton` was also the one place in the catalogs that used a\n * third colour - the vocabulary is dark for an action, light for a destructive\n * one, and nothing else. */\n.exportButton {\n  min-height: 34px;\n  border-radius: 7px;\n  padding: 0 14px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  /* Export is an action, so it takes the action fill like every other action\n     in the catalogs. It was the odd one out: a grey outline on a panel whose\n     other buttons were solid dark. */\n  border: 0;\n  background: var(--curio-top-bar-bg);\n  color: var(--curio-text-on-dark);\n}\n\n.exportButton:hover:not(:disabled) {\n  background: var(--curio-top-bar-bg-hover);\n}\n\n.exportButton:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* Its own inset now that `.pageHeader` does not pad: the tabs used to inherit\n * the header band's 24px and would otherwise sit flush against the edge. */\n.inspectorTabs {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  min-height: 36px;\n  margin-top: 4px;\n  padding: 0 24px;\n}\n\n.inspectorTabs button {\n  align-self: stretch;\n  border: 0;\n  border-bottom: 3px solid transparent;\n  background: transparent;\n  color: #777;\n  padding: 0 2px 8px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.inspectorTabActive {\n  color: #1e1f23 !important;\n  font-weight: 700 !important;\n  border-bottom-color: #1e1f23 !important;\n}\n\n/* Three-column split body (schema | main content | info+lineage) */\n.inspectorBody {\n  flex: 1;\n  display: grid;\n  grid-template-columns: minmax(240px, 20.6%) minmax(0, 1fr) minmax(280px, 27.8%);\n  min-height: 0;\n  overflow: hidden;\n}\n\n/* Focused tabs (Schema / Table Preview / Lineage) hide the schema column. */\n.inspectorBodyTwoCol {\n  grid-template-columns: minmax(0, 1fr) minmax(280px, 27.8%);\n}\n\n.schemaColumn,\n.centerColumn,\n.infoColumn {\n  min-height: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n}\n\n.schemaColumn > * {\n  flex: 1;\n  min-height: 0;\n}\n\n/* The scrollable columns (this one and .infoColumn) take the shared thin\n   scrollbar. */\n.centerColumn {\n  composes: thinScrollbar from \"../../../styles/scrollbars.module.css\";\n  border-left: 1px solid #e5e5e5;\n  border-right: 1px solid #e5e5e5;\n  overflow-y: auto;\n}\n\n.inspectorBodyTwoCol .centerColumn {\n  border-left: 0;\n}\n\n.previewSection {\n  flex-shrink: 0;\n}\n\n.previewSubtab {\n  min-height: 38px;\n  display: flex;\n  align-items: center;\n  padding: 0 20px;\n  background: #fafafa;\n  border-bottom: 1px solid #e5e5e5;\n}\n\n.previewSubtabActive {\n  font-size: 13px;\n  font-weight: 700;\n  color: #1e1f23;\n  padding-bottom: 8px;\n  border-bottom: 3px solid #1e1f23;\n}\n\n/* Expanded lineage view (center column, Lineage tab) */\n.lineageSection {\n  flex: 1;\n  min-height: 180px;\n  background: #fff;\n  padding: 16px 20px 24px;\n}\n\n.lineageHeader h2 {\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #1e1f23;\n}\n\n.liveBadge {\n  border-radius: 9px;\n  background: #f2f2f4;\n  color: #85858f;\n  padding: 2px 8px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.lineageHeader p {\n  margin: 6px 0 0;\n  color: #777;\n  font-size: 11px;\n}\n\n/* Compact lineage summary + states (right sidebar) */\n.lineageSummary {\n  margin: 0 0 10px;\n  color: #1e1f23;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.lineagePartialNote {\n  margin: 0 0 10px;\n  border-left: 2px solid #e3bf85;\n  color: #6b6b76;\n  padding: 2px 0 2px 8px;\n  font-size: 11px;\n}\n\n.lineageEmpty {\n  margin: 4px 0 8px;\n  color: #777;\n  font-size: 11px;\n}\n\n.lineageGroup {\n  margin: 0 0 10px;\n}\n\n.lineageGroupSummary {\n  cursor: pointer;\n  list-style-position: outside;\n  margin: 0 0 8px;\n  color: #999;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  user-select: none;\n}\n\n.statusPill {\n  align-self: center;\n  border-radius: 9px;\n  padding: 1px 8px;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.statusStale {\n  border: 1px solid #e8d7ba;\n  color: #8a6a30;\n}\n\n.statusBroken {\n  border: 1px solid #e8cfcf;\n  color: #97595a;\n}\n\n.lineageLabel {\n  margin: 22px 0 6px;\n  color: #1e1f23;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.lineageCard,\n.originCard,\n.consumedCard,\n.hubSourceCard {\n  position: relative;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 12px;\n  min-height: 40px;\n  margin: 0;\n  border: 0;\n  border-bottom: 1px solid #f0f0f0;\n  border-radius: 0;\n  background: transparent;\n  padding: 8px 0;\n  overflow: hidden;\n}\n\n.lineageCardBody {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.lineageCardBody strong,\n.originCard strong,\n.consumedCard strong,\n.hubSourceCard strong {\n  color: #1e1f23;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.lineageNodeBadge {\n  align-self: flex-start;\n  border-radius: 7px;\n  background: #f2f2f4;\n  color: #85858f;\n  padding: 1px 7px;\n  font-size: 8px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.lineageFlowName,\n.originCard span,\n.consumedCard span,\n.hubSourceCard span {\n  color: #777;\n  font-size: 11px;\n}\n\n\n/* Right info column */\n.infoColumn {\n  composes: thinScrollbar from \"../../../styles/scrollbars.module.css\";\n  overflow-y: auto;\n}\n\n.infoHeader {\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n  padding: 0 20px;\n  background: #fafafa;\n  border-bottom: 1px solid #ebebeb;\n  flex-shrink: 0;\n}\n\n.infoHeader h2 {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 700;\n  color: #1e1f23;\n}\n\n.infoSection {\n  padding: 16px 20px;\n  border-bottom: 1px solid #ebebeb;\n}\n\n.infoSectionLabel {\n  margin: 0 0 12px;\n  color: #999;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.infoRows {\n  margin: 0;\n}\n\n.infoRows > div {\n  display: grid;\n  grid-template-columns: minmax(100px, 1fr) minmax(0, 1.2fr);\n  gap: 12px;\n  align-items: center;\n  padding: 8px 0;\n  border-bottom: 1px solid #f5f5f5;\n  font-size: 13px;\n}\n\n.infoRows > div:last-child {\n  border-bottom: 0;\n}\n\n.infoRows dt {\n  margin: 0;\n  color: #555;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.infoRows dd {\n  margin: 0;\n  color: #1e1f23;\n  font-weight: 400;\n  text-align: right;\n}\n\n.originCard > div:first-child,\n.consumedCard > div:first-child {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n/* hubSourceCard puts its name and caption straight in the row. */\n.hubSourceCard {\n  grid-template-columns: minmax(0, 1fr);\n  align-content: center;\n  row-gap: 2px;\n}\n\n.hubSourceCard strong {\n  color: #1e1f23;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.hubSourceCard span {\n  color: #777;\n  font-size: 11px;\n}\n\n.tagList {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.tagChip {\n  display: inline-flex;\n  align-items: center;\n  min-height: 22px;\n  border-radius: 11px;\n  background: #f0f0f0;\n  color: #555;\n  padding: 0 12px;\n  font-size: 11px;\n}\n\n.loading,\n.error {\n  margin: 0;\n  padding: 24px;\n  text-align: center;\n  color: #777;\n  font-size: 13px;\n}\n\n.error {\n  color: #9f3f3f;\n}\n\n@media (max-width: 1100px) {\n  .inspectorBody {\n    grid-template-columns: minmax(200px, 28%) minmax(0, 1fr);\n    grid-template-rows: minmax(0, 1fr) auto;\n  }\n\n  .inspectorBodyTwoCol {\n    grid-template-columns: minmax(0, 1fr);\n    grid-template-rows: minmax(0, 1fr) auto;\n  }\n\n  .schemaColumn {\n    grid-row: 1 / span 2;\n  }\n\n  .infoColumn {\n    grid-column: 2;\n  }\n\n  .inspectorBodyTwoCol .infoColumn {\n    grid-column: 1;\n  }\n\n  .centerColumn {\n    border-right: 0;\n  }\n}\n\n@media (max-width: 760px) {\n  .headerMain {\n    flex-direction: column;\n  }\n\n  .inspectorBody {\n    display: block;\n    overflow: auto;\n  }\n\n  .schemaColumn,\n  .centerColumn,\n  .infoColumn {\n    min-height: 320px;\n    border: 0;\n    border-bottom: 1px solid #e5e5e5;\n  }\n}\n\n/* \"Use in a node\": the reference to paste, and where the bytes live (#206). */\n.referenceRow {\n    display: flex;\n    /* The info column is about 240 px wide and the labelled Copy button takes\n       about 174 of them, which left the code a 45 px box (#500). The code gets\n       the row to itself and the button goes under it. */\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n}\n\n.referenceCode {\n    flex: 1 1 100%;\n    /* A reference is one token and can be long, and a layer group's is its\n       loader, a line per layer; keep the lines and scroll them rather than wrap\n       code the reader is about to copy. */\n    min-width: 0;\n    overflow-x: auto;\n    white-space: pre;\n    padding: 6px 8px;\n    border-radius: var(--curio-radius-sm);\n    background: var(--curio-page-bg);\n    font-family: 'Source Code Pro', Consolas, 'Courier New', monospace;\n    font-size: var(--curio-font-size-sm);\n    color: var(--curio-text-primary);\n}\n\n.referenceLocation {\n    margin: 6px 0 0;\n    /* Informational: the machine-specific location, which is exactly what\n       should NOT be pasted into a node. */\n    overflow-wrap: anywhere;\n    font-size: var(--curio-font-size-sm);\n    color: var(--curio-text-muted);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalRoot": `xPGB8CoeNCacgtsb24pu`,
	"inspector": `UyAPUAAxxSpIgmHIXrFv`,
	"pageHeader": `govLgMqvf19UZSjaqi_z`,
	"breadcrumb": `hGHvAM_1oGc1rjkvabD5`,
	"headerMain": `nPGvhyMsWjSpJdpFkqeM`,
	"titleBlock": `Ig1xFQojYOAaLK9Y133S`,
	"datasetIcon": `M8dBsLmmV9mPsnfqInxt`,
	"icon_mint": `bpoWsK2lLsYzy916CoEw`,
	"icon_sky": `hUEo5yq6QZZT81UVs7pw`,
	"icon_lilac": `uYl2lPJkd94ExEXE5X8m`,
	"inspectorHeader": `Xz4ysZlQywAu9Lorz056`,
	"inspectorMeta": `PMjHgaIE4xFiCKQhoxsu`,
	"metaDot": `wW91JI1D3HYNYhdU1LkA`,
	"formatChip": `TiQ66T8yoO86yTDbKRBZ`,
	"installedBadge": `Tcjb3lA6WKjfF_Tc31VU`,
	"format_geojson": `D1JS5NOycDERk4YMB8yl`,
	"format_csv": `m1yOVubNLVVDRIaufqr2`,
	"format_json": `nWRlY5VsCV9Ps2y9W7Nw`,
	"format_parquet": `hOWv813TkvxaZ8wWhyQY`,
	"format_geotiff": `FX1q6M3b1AfXxWTyylVj`,
	"format_shp": `t4S8EJheoafyuKSmphDv`,
	"format_bundle": `wlAtUFEkrBIvb6q5JbB5`,
	"format_osm": `FZRY1n9F_WKS4uwdhoz0`,
	"format_gpkg": `kpbHYM3hFzeczrqpPdBz`,
	"format_gtfs": `TXtTK3w_kB8PZZyA8PS0`,
	"format_collection": `YQNkHREMUa49fE_wZpGE`,
	"format_onnx": `KBZuxgr_PUob_qA9sjlN`,
	"format_netcdf": `Jo_REQxlOIL9OyrxIjRh`,
	"inspectorActions": `XJTNgdhK7KUkyNStkaA_`,
	"exportButton": `o9_z8rXBLUJ9oZfzJ7xw`,
	"inspectorTabs": `UnOH6pP3wTz7ebnslHLK`,
	"inspectorTabActive": `P367ON01mFW3diV7Jjle`,
	"inspectorBody": `UtphHzorqJ5l1pMW0Rct`,
	"inspectorBodyTwoCol": `iAPP2zfyahJJtiIJPpfH`,
	"schemaColumn": `Y2A2sLIsg1FJyNHOmIwK`,
	"centerColumn": `oTZoOKQv5T8Fe_z6djyg ${___CSS_LOADER_ICSS_IMPORT_0___.locals["thinScrollbar"]}`,
	"infoColumn": `a_3E3fas3zeTaWdwTR5c ${___CSS_LOADER_ICSS_IMPORT_0___.locals["thinScrollbar"]}`,
	"previewSection": `FhG0BBPlN6jVARS4FOzY`,
	"previewSubtab": `ouTpcgrunBKv5XnHT3oB`,
	"previewSubtabActive": `RJgusxnq_SyOCNgadxN3`,
	"lineageSection": `mManFzCvgziXHPuxgrXo`,
	"lineageHeader": `o7CT9QHrO1WCHrl6QN0g`,
	"liveBadge": `GOTQL_1IWr1_YqlkH5_P`,
	"lineageSummary": `p9MpLRAENshkzkiU8mkr`,
	"lineagePartialNote": `cnxbDwENt4Ov0WiuD2Tf`,
	"lineageEmpty": `fS7VMFnAaaCXHDSgJx6C`,
	"lineageGroup": `ddmPjoZPGLBErUHVicJg`,
	"lineageGroupSummary": `zjq3mseBkati74mtWdFj`,
	"statusPill": `PvfYIx0Abj6hL_sGTHuy`,
	"statusStale": `mSOWEPZeZ7LXrdGQvIQd`,
	"statusBroken": `qPY84pBx7CDdWJYtjoHN`,
	"lineageLabel": `aet0QYgpHFDEyADTtwCK`,
	"lineageCard": `BMSFMyf0yZ08K7j7cWei`,
	"originCard": `ju4kk9e5xM4cHetTsqjy`,
	"consumedCard": `AratndiDzIWsgelNTVCd`,
	"hubSourceCard": `mMlKVhOUdVfI9CLplSp8`,
	"lineageCardBody": `SYg1oI1uIrBSNFflG2wr`,
	"lineageNodeBadge": `KTm4b9WdsEcHEMQ4fDHv`,
	"lineageFlowName": `blbJeD8z6xaKYVLR50mE`,
	"infoHeader": `_Z7q8oEeHd1pmID1IU2r`,
	"infoSection": `Mufrd3mp5sZkEvfoGj_A`,
	"infoSectionLabel": `FhKnCqCpscte4rsvm4b7`,
	"infoRows": `MP5XbGftZSDbrdtrncDb`,
	"tagList": `cKqIgsAsdMxSHG5_ShAw`,
	"tagChip": `iHrG3aGcbXeDyxVt417d`,
	"loading": `gre3QeJFACrByDo3wahG`,
	"error": `oBCq8S0DX8JbqOoaYaGE`,
	"referenceRow": `MUmooIXZI7Z0Iv2neU9o`,
	"referenceCode": `_0J_BE44qbEYMHa3FPrO5`,
	"referenceLocation": `jcEm8zRG385n1QXUrZe3`
};
export default ___CSS_LOADER_EXPORT___;
